(() => {
  if (customElements.get('jb-catalog-controls')) return;
  customElements.define('jb-catalog-controls', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const setup = () => {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        this.root = this.closest('#ProductGridContainer');
        let view = 'grid';
        try { view = sessionStorage.getItem('jb-catalog-view') || 'grid'; } catch {}
        this.setView(view);
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-view]');
          if (button) this.setView(button.dataset.view);
        }, { signal: this.controller.signal });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
      else setup();
    }
    setView(view) {
      if (!this.root) return;
      view = view === 'feed' ? 'feed' : 'grid';
      this.root.dataset.view = view;
      this.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === view)));
      try { sessionStorage.setItem('jb-catalog-view', view); } catch {}
      this.dispatchEvent(new CustomEvent('jb:view-changed', { bubbles: true }));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
})();
